var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isError)?_c('div',{attrs:{"id":_vm.svgId}}):_c('el-empty',{staticClass:"empty",attrs:{"description":"加载SVG失败"}})
}
var staticRenderFns = []

export { render, staticRenderFns }